import { render } from "./FieldTypesList.vue?vue&type=template&id=d095c028"
import script from "./FieldTypesList.vue?vue&type=script&lang=js"
export * from "./FieldTypesList.vue?vue&type=script&lang=js"

import "./FieldTypesList.vue?vue&type=style&index=0&id=d095c028&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__